/**
 * ABWIN Scratch Popup — Analytics
 * ---------------------------------------------------------------
 * Event architecture. Console-logged when analytics.devLogging is true,
 * and dispatched as a `abwin:analytics` CustomEvent on `window` so a
 * real integration (GA4/Segment/Klaviyo) can attach a listener without
 * touching popup.js/email.js/discount.js.
 */
(function (global) {
  "use strict";

  const cfg = global.ABWIN_POPUP_CONFIG;

  const EVENTS = Object.freeze({
    POPUP_VIEWED: "popup_viewed",
    SCRATCH_STARTED: "scratch_started",
    SCRATCH_COMPLETED: "scratch_completed",
    REWARD_REVEALED: "reward_revealed",
    CLAIM_CLICKED: "claim_clicked",
    EMAIL_FORM_VIEWED: "email_form_viewed",
    EMAIL_SUBMITTED: "email_submitted",
    EMAIL_SUBMISSION_FAILED: "email_submission_failed",
    DISCOUNT_REVEALED: "discount_revealed",
    DISCOUNT_COPIED: "discount_copied",
    SHOP_NOW_CLICKED: "shop_now_clicked",
    POPUP_CLOSED: "popup_closed",
  });

  function getUtmParams() {
    const params = new URLSearchParams(global.location.search);
    return {
      utm_source: params.get("utm_source"),
      utm_medium: params.get("utm_medium"),
      utm_campaign: params.get("utm_campaign"),
    };
  }

  function getDeviceType() {
    const w = global.innerWidth;
    if (w < cfg.mobile.breakpointPx) return "mobile";
    if (w < 1024) return "tablet";
    return "desktop";
  }

  function track(name, payload) {
    const detail = {
      name,
      payload: Object.assign(
        {
          popupVersion: cfg.popupVersion,
          pageUrl: global.location.href,
          device: getDeviceType(),
          timestamp: new Date().toISOString(),
          discountCode: cfg.discount.code,
        },
        getUtmParams(),
        payload || {}
      ),
    };

    if (cfg.analytics.devLogging) {
      console.log(`[abwin-analytics] ${name}`, detail.payload);
    }

    global.dispatchEvent(new CustomEvent("abwin:analytics", { detail }));
  }

  global.AbwinAnalytics = { EVENTS, track };
})(window);
